import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {List} from "immutable";
import connect from "react-redux/es/connect/connect";
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import numeral from "numeral";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import {cleanSalesOrders, getSalesOrders} from "../../../actions/sales-orders";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class CustomerOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            salesOrderFilters: ''
        };
    }
    componentDidMount() {
        this.props.getSalesOrders({
            filters: { customer: this.props.customerId },
            projection: 'order_code document_date expected_delivery_date customer statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'customer',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'sales-orders',
            deleteVirtuals: true
        });
    }

    componentWillUnmount() {
        this.props.cleanSalesOrders();
    }

    render() {
        let tableData = this.props.salesOrders;

        // Filters Zone
        let totalOrders = 0;
        this.props.salesOrders.forEach(order => totalOrders = totalOrders + order.getIn(['statistics', 'total']));
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label ">{ numeral(totalOrders).format() }</span>
                    <span>Importe Total</span>
                </div>
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.salesOrders.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: '' }) }><strong>Pedidos</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.salesOrders.count(order => order.get('status') === 'sent') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'sent' }) }>Enviados</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning">{ this.props.salesOrders.count(order => order.get('status') === 'in_progress') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'in_progress' }) }>En proceso</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning-light">{ this.props.salesOrders.count(order => order.get('status') === 'partial') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'partial' }) }>Parciales</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.salesOrders.count(order => order.get('status') === 'pending') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'pending' }) }>Pendientes</span>
                </div>
                { this.props.status === 'active'
                    ? <div className="col-auto ml-auto">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.props.history.push('/ventas/pedidos/nuevo', { customerId: this.props.customerId }) }
                        >
                            <Icon icon="insert"/>Pedido
                        </button>
                    </div>
                    : null
                }
            </div>
        );

        switch (this.state.salesOrderFilters) {
            case 'sent':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary"><strong>{this.props.salesOrders.count(order => order.get('status') === 'sent')}</strong></span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}><strong>Enviados</strong></span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning">{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}>En proceso</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light">{this.props.salesOrders.count(order => order.get('status') === 'partial')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'partial'})}>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger">{this.props.salesOrders.count(order => order.get('status') === 'pending')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'pending'})}>Pendientes</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/pedidos/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Pedido
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'sent');
                break;
            case 'in_progress':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary">{this.props.salesOrders.count(order => order.get('status') === 'sent')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}>Enviados</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning"><strong>{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</strong></span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}><strong>En proceso</strong></span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light">{this.props.salesOrders.count(order => order.get('status') === 'partial')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'partial'})}>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger">{this.props.salesOrders.count(order => order.get('status') === 'pending')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'pending'})}>Pendientes</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/pedidos/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Pedido
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'in_progress');
                break;
            case 'partial':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary">{this.props.salesOrders.count(order => order.get('status') === 'sent')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}>Enviados</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning">{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}>En proceso</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light"><strong>{this.props.salesOrders.count(order => order.get('status') === 'partial')}</strong></span>
                            <span className="handPointer" onClick={() => this.setState({salesOrderFilters: 'partial'})}><strong>Parciales</strong></span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger">{this.props.salesOrders.count(order => order.get('status') === 'pending')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'pending'})}>Pendientes</span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/pedidos/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Pedido
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'partial');
                break;
            case 'pending':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary">{this.props.salesOrders.count(order => order.get('status') === 'sent')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}>Enviados</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning">{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}>En proceso</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light">{this.props.salesOrders.count(order => order.get('status') === 'partial')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'partial'})}>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger"><strong>{this.props.salesOrders.count(order => order.get('status') === 'pending')}</strong></span>
                            <span className="handPointer" onClick={() => this.setState({salesOrderFilters: 'pending'})}><strong>Pendientes</strong></span>
                        </div>
                        { this.props.status === 'active'
                            ? <div className="col-auto ml-auto">
                                <button
                                    className="btn btn-primary"
                                    onClick={ () => this.props.history.push('/ventas/pedidos/nuevo', { customerId: this.props.customerId }) }
                                >
                                    <Icon icon="insert"/>Pedido
                                </button>
                            </div>
                            : null
                        }
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'pending');
                break;
            default:
                break;
        }

        // SalesOrders Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            order_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'order_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/pedidos/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expected_delivery_date: {
                title: "Fecha prevista de entrega",
                columnType: 'date',
                dataField: 'expected_delivery_date',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            customer: {
                title: "Cliente",
                columnType: 'text',
                dataField: 'customer',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'pending':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        case 'in_progress':
                            data.badgeColor = 'warning';
                            data.value = 'En Proceso';
                            break;
                        case 'partial':
                            data.badgeColor = 'warning-light';
                            data.value = 'Parcial';
                            break;
                        case 'sent':
                            data.badgeColor = 'primary';
                            data.value = 'Enviado';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/pedidos/' + value[0])} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div className="panel-body">
                { statsZone }
                <div className="row">
                    <div className="col">
                        <div className="ibox">
                            <div className="ibox-content">
                                <VirtualizedTable
                                    tableSettings={tableSettings}
                                    tableColumns={tableColumns}
                                    tableData={tableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {

    // Reducers
    const salesOrdersReducer = state.salesOrders;

    // SalesOrders
    let salesOrders = salesOrdersReducer.get('payload') || List([]);

    if (!(salesOrders instanceof List)) {
        salesOrders = List([])
    }

    return {
        salesOrders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSalesOrders: (query) => dispatch(getSalesOrders(query)),
        cleanSalesOrders: () => dispatch(cleanSalesOrders())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrders);



// WEBPACK FOOTER //
// ./src/containers/sales/customers/CustomerOrders.js